import React, { ReactElement, useEffect, useState } from 'react';
import Header from '../../components/Header';
import styled from 'styled-components';
import { Link, useNavigate } from 'react-router-dom';

export default function DiagnosisMyPage(): ReactElement {
	const navigate = useNavigate();
	const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
	const [isLoggedIn, setIsLoggedIn] = useState(false); // 로그인 상태 관리
	const [nickname, setNickname] = useState<string | null>(null); // 사용자 닉네임 관리
	const [uid, setUid] = useState<string | null>(null);
	useEffect(() => {
		// 로컬 스토리지에서 로그인 정보 확인
		const storedLogin = localStorage.getItem('login');
		const storedUser = localStorage.getItem('user');

		if (storedLogin) {
			console.log('Stored JWT Token:', JSON.parse(storedLogin).jwtToken);
			setIsLoggedIn(true);
		}

		if (storedUser) {
			const userInfo = JSON.parse(storedUser);
			setNickname(userInfo.nickname); // 닉네임 설정
			setUid(userInfo.uid);
		}
	}, []);

	return (
		<Layout>
			
			{nickname}
			{uid}
		</Layout>
	);
}

const Layout = styled.div`
	width: 100vw; /* 화면 너비에 맞춤 */
	height: 100vh; /* 화면 높이에 맞춤 */
	overflow-x: hidden; /* 좌우 스크롤 방지 */
`;
